import { useCallback, useState } from "react";
import type { ThemeFieldPreview } from "containers/theme-setter/types";
import { FieldPreviewModal } from "containers/theme-setter/components/FieldPreviewModal";

type FieldInfoButtonProps = {
  label: string;
  preview: ThemeFieldPreview;
};

export const FieldInfoButton = ({ label, preview }: FieldInfoButtonProps) => {
  const [open, setOpen] = useState(false);
  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <>
      <button
        type="button"
        aria-label={`Preview ${label}`}
        className="rounded-full text-gray-400 transition-colors hover:text-primary focus:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60"
        onClick={() => setOpen(true)}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M12 8h.01M11 11h1v5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {open && (
        <FieldPreviewModal label={label} preview={preview} onClose={closeModal} />
      )}
    </>
  );
};
